/* eslint-disable no-prototype-builtins */
import { CACHE_CONFIG_TYPES } from '@intigral/constant';
import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '@intigral/domain/lib/DataDomain';
import { get } from '@intigral/utils/lib/browser-storage/localStorage';
import { getConfiguration } from '../hooks/useConfiguration';
import users from '../actions/users';
import { appConfig } from '../config/app.config';
import { cookiesNames, screenDetailTypes, STORE_NAME, TIERS_NAME_CONFIG, userStatus } from '../config/constants';
import { getDeviceFingerprint } from '@intigral/utils';
import { deleteUser } from '../store/reducers/userSlice';
import { persistSessionUser, persistUserWithSubscription } from '../utils/user';
import browser from './browser';
import h, { appData, getGuid, getReduxGlobal } from './common';
import url from './url';
let localDevice = null;
import { PPV_PURCHASE_OPTIONS } from '@intigral/constant';

export const TVODPurchaseOption = {
    NONE: null,
    OTP: 'OTP',
    PASSWORD: 'PASSWORD',
    PIN: 'PIN',
};

const user = {
    getDeviceInfo: () => {
        if (localDevice) {
            return localDevice;
        } else {
            localDevice = h.getStore(STORE_NAME.DEVICE);
            return localDevice;
        }
    },
    deleteUserLoginAttemptCookie: () => {
        h.deleteCookie(cookiesNames.USER_LOGIN_ATTEMPT, false);
    },
    isValidUserCookie: (userCookie) => {
        return (
            !!userCookie.username &&
            !!userCookie.authToken &&
            !!userCookie.guid &&
            !!userCookie.operator &&
            !!userCookie.authSign
        );
    },
    ssoLogin: async (config) => {
        let userLocalSession = h.getStore(STORE_NAME.USER);
        const userLoginTokenParam = h.getCookie(cookiesNames.USER_SESSION);
        if (userLocalSession && !userLocalSession.createdTime) {
            userLocalSession.createdTime = Date.now();
            h.setStore(STORE_NAME.USER, userLocalSession);
        }

        /** If user cookie exists */
        if (typeof userLoginTokenParam === 'string' && userLoginTokenParam.trim().length > 0) {
            let userLoginToken = window.atob(decodeURIComponent(userLoginTokenParam));
            if (!h.isJsonString(userLoginToken)) {
                return userLocalSession || null;
            }
            userLoginToken = JSON.parse(userLoginToken);

            /** If username of cookie is matching username from localstorage*/
            if (userLocalSession?.username) {
                let { username, authToken } = userLocalSession;
                if (username !== undefined && typeof username !== 'undefined' && username !== null) {
                    let { u: cookieUsername, t: cookieToken } = userLoginToken;
                    if (
                        cookieUsername &&
                        cookieToken &&
                        username.trim().toLocaleLowerCase() === cookieUsername.trim().toLocaleLowerCase() &&
                        authToken === cookieToken
                    ) {
                        if (
                            username.trim().toLocaleLowerCase() === cookieUsername.trim().toLocaleLowerCase() &&
                            authToken === cookieToken
                        ) {
                            return userLocalSession;
                        }
                    }
                }
            }
            /** Generate auto login request using cookie's refresh token */
            const userData = await users.loginUserWithToken(userLoginToken, config);
            if (userData?.refreshTokenError) {
                return userData; // will be: { refreshTokenError: true, code: Number }
            }
            if (!userData?.username) {
                return null;
            }
            user.storeUserInfo(userData);
            return userData;
        }
        return userLocalSession || null;
    },
    getUserInfo: () => {
        let userLocalSession = h.getStore(STORE_NAME.USER);
        if (userLocalSession !== null) return userLocalSession;
    },
    storeUserInfo: (data) => persistSessionUser(data),
    deleteUserInfoStore: () => {
        const store = getReduxGlobal();
        store.dispatch(deleteUser());
    },
    isUserLoggedIn: async (config) => {
        const info = await user.getUserInfo(config);
        return !!(info && info.username);
    },
    getUserLogoutUrl: () => {
        const url = new URL(window.location.href);
        const movieId = url.searchParams.get('movie');
        const guid = url.searchParams.get('guid');
        const qitafRedirect = url.searchParams.get('qitafRedirect');
        if (movieId && guid && qitafRedirect) {
            sessionStorage.setItem('redirect', window.location.href);
        }
        const lang = h.getLang() === appConfig.defaultLanguage ? '' : h.getLang();
        if (lang === '') {
            return appConfig.userLogoutUrl.replace('{LANG}/', lang);
        }
        return appConfig.userLogoutUrl.replace('{LANG}', lang);
    },
    getUserForceLogoutUrl: () => {
        const lang = h.getLang() === appConfig.defaultLanguage ? '' : h.getLang();
        if (lang === '') {
            return appConfig.userForceLogoutUrl.replace('{LANG}/', lang);
        }
        return appConfig.userForceLogoutUrl.replace('{LANG}', lang);
    },
    getUserProfileUrl: () => {
        const lang = h.getLang() === appConfig.defaultLanguage ? '' : h.getLang();
        if (lang === '') {
            return appConfig.userProfileUrl.replace('{LANG}/', lang);
        }
        return appConfig.userProfileUrl.replace('{LANG}', lang);
    },
    getUsername: () => {
        const tmpUser = user.getUserInfo();
        return tmpUser?.username || '';
    },
    getMSISDN: () => {
        const tmpUser = user.getUserInfo();
        return tmpUser ? tmpUser.msisdn : '';
    },
    getProfileName: () => {
        const guestUser = user.getUserInfo();
        if (guestUser?.isGuest === true) {
            return 'default';
        }
        const selectedProfile = h.getStore(STORE_NAME.SELECTED_PROFILE);
        return selectedProfile && selectedProfile.profileName
            ? selectedProfile.profileName
            : appConfig.userDefaultProfileName;
    },
    getProfile: () => {
        const selectedProfile = h.getStore(STORE_NAME.SELECTED_PROFILE);
        return selectedProfile;
    },
    getProfileMode: () => {
        const selectedProfile = h.getStore(STORE_NAME.SELECTED_PROFILE);
        return selectedProfile && selectedProfile.kidsMode === true ? 'kid' : 'parent';
    },
    getParentalLockOn: () => {
        const selectedProfile = h.getStore(STORE_NAME.USER_PROFILE_LIST);
        return selectedProfile?.parentalLockOn ?? 0;
    },
    getUserToken: () => {
        return user.getUserInfo()?.authToken;
    },
    getAPIKey: () => {
        return user.getUserInfo()?.apiKey;
    },
    getSubscriptionVersion: () => {
        return user.getUserInfo()?.subscriptionRev;
    },
    getIdentityToken: () => {
        const objUser = user.getUserInfo();
        return objUser ? objUser.identityToken : '';
    },
    getUserGuId: () => {
        return user.getUserInfo()?.guid;
    },
    getUserSegment: () => {
        return user.getUserInfo()?.segment;
    },
    getUserEnvironmentContext: () => {
        try {
            return user.getUserInfo()?.userEnvironmentContext;
        } catch (e) {
            return null;
        }
    },
    getGroupId: () => {
        return user.getUserInfo()?.group;
    },
    getAccountId: () => {
        return user.getUserInfo()?.accountId;
    },
    getUid: () => {
        return user.getUserInfo()?.uid;
    },
    getUserDeviceId: () => {
        const userInfo = user.getUserInfo();
        const isGuest = userInfo?.isGuest === true;
        return getDeviceFingerprint(user.getUsername() + ''.toLowerCase(), isGuest);
    },

    isDefaultUser: () => {
        const userInfo = user.getUserInfo();
        if (userInfo && userInfo.operator.toUpperCase() === userStatus.OPERATOR) {
            return true;
        }
        return false;
    },
    isActiveSubscribedUser: () => {
        const userInfo = user.getUserInfo();
        if (user.isDefaultUser()) {
            return true;
        } else {
            if (
                userInfo &&
                typeof userInfo.subscriptionStatus !== 'undefined' &&
                userInfo.subscriptionStatus.length > 0
            ) {
                for (let i = 0; i < userInfo.subscriptionStatus.length; i++) {
                    if (
                        typeof userInfo.subscriptionStatus[i] !== 'undefined' &&
                        userInfo.subscriptionStatus[i].hasOwnProperty('statusName') &&
                        (userInfo.subscriptionStatus[i]?.statusName === 'ACTIVE' ||
                            userInfo.subscriptionStatus[i]?.statusName === 'CANCELLED')
                    ) {
                        return true;
                    }
                }
            }
            return false;
        }
    },
    getUserSubscribedPackages: () => {
        let guids = getGuid();
        guids = guids.split('|');
        if (!guids || !guids.length) return [];
        return guids.map((guid) => {
            return {
                subscriptionGuid: guid,
            };
        });
    },
    /**
     *  Function to update context with active user subscriptions
     * @returns {boolean}
     */
    setUserActiveSubscribedGuids: () => {
        let activeSubscriptionGuids = [];
        const userInfo = user.getUserInfo();
        if (userInfo && typeof userInfo.subscriptionStatus !== 'undefined' && userInfo.subscriptionStatus.length > 0) {
            for (let i = 0; i < userInfo.subscriptionStatus.length; i++) {
                if (
                    typeof userInfo.subscriptionStatus[i] !== 'undefined' &&
                    userInfo.subscriptionStatus[i].hasOwnProperty('statusName') &&
                    (userInfo.subscriptionStatus[i]?.statusName === 'ACTIVE' ||
                        userInfo.subscriptionStatus[i]?.statusName === 'CANCELLED')
                ) {
                    activeSubscriptionGuids[i] = userInfo.subscriptionStatus[i].subscriptionGuid;
                }
            }
        }
        h.setContext({ activeSubscriptionGuids });
        return true;
    },
    /**
     *  Function to update context with tier status
     * @returns {boolean}
     */
    setUserTierStatus: () => {
        let tierStatus = [];
        const userInfo = user.getUserInfo();

        if (userInfo && typeof userInfo.tierStatus !== 'undefined') {
            tierStatus = userInfo.tierStatus;
        }
        h.setContext({ tierStatus });
        return true;
    },

    /**
     *  Function to update context with tier config
     * @returns {boolean}
     */
    setUserTierConfig: () => {
        let tierConfig = [];
        const userInfo = user.getUserInfo();

        if (userInfo && typeof userInfo.tierConfig !== 'undefined') {
            tierConfig = userInfo.tierConfig;
        }
        h.setContext({ tierConfig });
        return true;
    },
    /**
     * Function to get array of active user subscriptions
     * @returns {*[]}
     */
    getUserActiveSubscribedGuids: () => {
        return appData.activeSubscriptionGuids ? appData.activeSubscriptionGuids : [];
    },
    getUserTierConfig: () => {
        return appData.tierConfig ? appData.tierConfig : [];
    },
    getUserTierStatus: () => {
        return appData.tierStatus ? appData.tierStatus : [];
    },
    getUserActiveTierGuid: () => {
        const userInfo = user.getUserInfo();
        return userInfo?.tierConfig?.tierGuid || null;
    },
    getUserTierName: () => {
        const { tierConfig } = appData || {};
        const localConfig = getConfiguration();
        const tiersNameObj = localConfig?.tierConfig?.tiersName || TIERS_NAME_CONFIG || {};

        const currentUserTier = tierConfig?.tierName || null;
        if (!currentUserTier) {
            return 'NA';
        }

        return tiersNameObj[currentUserTier.toLowerCase()] || currentUserTier;
    },
    getUserActiveTierGuidV2: (config) => {
        return config?.tierConfig?.tierGuid || null;
    },
    getProfileAvatar: ($type = 'profile') => {
        const configs = getConfiguration();
        return $type === 'profile' ? configs?.profile?.profileAvatar : configs?.profile?.kidsAvatar;
    },
    getMyAccountUrl: () => {
        const config = getConfiguration();
        const langLabel = h.getLang();
        let link = config?.externalLinks?.myAccount;
        return langLabel === 'en' ? link.replace('{LANG}', langLabel) : link.replace('{LANG}/', '');
    },
    getDRMLicense: (type) => {
        const device = user.getDeviceInfo();
        if (device) {
            return device[type];
        }
        return null;
    },
    getUserDevice: () => {
        return {
            deviceMake: browser.name(),
            deviceModel: browser.nameWithVersion(),
            deviceOSVerion: browser.os(),
            deviceName: browser.nameWithVersion() + ' on ' + browser.os(),
            deviceUniqueIdentifier: user.getUserDeviceId(),
            deviceType: h.getVMXDeviceName(),
            vmxDeviceId: user.getUserDeviceId(),
            vmxDeviceType: h.getVMXDeviceName(),
            deviceGuid: h.getDeviceGuid(),
        };
    },

    setJpAuthType: () => {
        h.setStore('_isjp', true);
    },
    isJPAuthType: () => {
        let jp = h.getStore('_isjp');
        return !!jp && jp !== null;
    },
    /**
     * check max devices context value
     * @returns {boolean}
     */
    checkMaxDevicesReached: () => {
        return appData.maxDevicesReached;
    },
    /**
     * Function to redirect if user Reach the max devices
     * @returns {boolean}
     */
    isMaxDevicesReached: (maxDevicesReached = false, redirect = true) => {
        let userProfileRoute = url.getDetailsPage(screenDetailTypes.PROFILE_SETTINGS);
        let selectProfileRoute = url.getDetailsPage(screenDetailTypes.PROFILE_SELECT);
        if (
            (maxDevicesReached || user.checkMaxDevicesReached()) &&
            !url.isCurrentRoute(selectProfileRoute) &&
            !url.isCurrentRoute(userProfileRoute)
        ) {
            if (redirect) window.location = url.route(userProfileRoute);
            return true;
        }
        return false;
    },
    /**
     * Return the profiles list from the API if it's not already loaded in the local storage
     * ignoreLocalProfiles: Set true will always load from the profiles API
     */
    initiatedUserProfiles: async (ignoreLocalProfiles = false) => {
        const selectedProfile = get(STORE_NAME.SELECTED_PROFILE);
        const kidsMode = selectedProfile ? selectedProfile.kidsMode === true : false;
        let localProfilesList = h.getStore(STORE_NAME.USER_PROFILE_LIST);
        if (
            typeof localProfilesList !== 'undefined' &&
            localProfilesList !== null &&
            !!localProfilesList &&
            !ignoreLocalProfiles &&
            localProfilesList.kidsMode === kidsMode
        ) {
            return localProfilesList;
        } else {
                const profileService = container.resolve(DI.SERVICES.IProfileService);
                const profilesList = await profileService.getProfiles(
                    user.getAPIKey(),
                    user.getUserToken(),
                    user.getIdentityToken(),
                    kidsMode
                );
                let { profiles, profilesRev, profilesLimit, parentalLockOn } = profilesList;
                if (typeof profiles !== 'undefined' && profiles !== null && !!profiles) {
                    // set avatar index
                    let regProfileIndex = 0;
                    profiles?.map((el) => {
                        if (!el.kidsMode) {
                            el.avatarIndex = regProfileIndex;
                            regProfileIndex++;
                        }
                    });
                    let date = new Date().getTime();
                    h.setStore(STORE_NAME.USER_PROFILE_LIST, {
                        parentalLockOn: parentalLockOn ?? 0,
                        profiles: profiles,
                        profilesLimit: profilesLimit,
                        profileRev: profilesRev,
                        kidsMode: kidsMode,
                        date: date,
                    });
                    return profilesList;
                }
        }
    },
    isSelectedProfileDeleted: (selectedProfile, profileList) => {
        if (!selectedProfile.profileGuid) {
            return false;
        }
        return !profileList.some((profile) => profile.profileGuid === selectedProfile.profileGuid);
    },
    isAllowedProfileActions: () => {
        const userInfo = user.getUserInfo();
        return userInfo.segment && userInfo.segment === 'B2C' ? true : false;
    },
    isForceLogoutAblied: (flRev) => {
        if (user.getUserInfo()?.isGuest === true) {
            return false;
        }
        const subscriptionRev = user.getSubscriptionVersion();
        const isLarger = !!(flRev && subscriptionRev && flRev > subscriptionRev);
        return isLarger;
    },
    isUserSubscriptionRevChanges: (subRev) => {
        if (user.getUserInfo()?.isGuest === true) {
            return false;
        }
        const subscriptionRev = user.getSubscriptionVersion();
        if (subRev && subscriptionRev && subRev > subscriptionRev) {
            return true;
        }
        return false;
    },

    updateUserSubscriptionsObject: (subscription, reloadThePage = true) => {
        persistUserWithSubscription(h.getStore(STORE_NAME.USER), subscription);

        const selectProfileRoute = url.getDetailsPage(screenDetailTypes.PROFILE_SELECT);
        if (!url.isCurrentRoute(selectProfileRoute) && reloadThePage) {
            // eslint-disable-next-line no-self-assign
            window.location.href = window.location.href;
        }
    },
    hasUserHigherTiers: () => {
        //  FIXED: Using React Query configuration instead of appData
        const config = getConfiguration();
        const maxTierRank = config?.tierConfig?.maxTierRank ?? 0;
        const tierConfig = user.getUserTierConfig();
        const tierRank = tierConfig?.tierRank ?? 0;

        return tierRank < maxTierRank;
    },

    getTVODPurchaseOption: (userOperator) => {
        const configs = getConfiguration();
        userOperator = (userOperator || '').toLowerCase();
        let operatorConfig = configs?.operators;
        operatorConfig = Object.keys(operatorConfig || {}).reduce((acc, operator) => {
            acc[operator.toLowerCase()] = operatorConfig[operator];
            return acc;
        }, {});
        if (!userOperator || !operatorConfig) return TVODPurchaseOption.NONE;
        const userOperatorConfig = operatorConfig[userOperator];
        if (!userOperatorConfig) return TVODPurchaseOption.NONE;
        const purchaseOption = userOperatorConfig['tvod']?.defaultPurchaseOption?.toUpperCase();
        return userOperatorConfig['tvod'].enable ? TVODPurchaseOption[purchaseOption] : TVODPurchaseOption.NONE;
    },

    isBundleAndSaveEnabled: (userOperator) => {
        const configs = getConfiguration();
        const operators = configs?.operators;
        if (!userOperator || !operators) return false;

        const normalizedOperator = userOperator.toLowerCase();
        return Object.keys(operators).some(
            (operator) =>
                operator.toLowerCase() === normalizedOperator &&
                operators[operator]?.bundleAndSave?.enable === true
        );
    },

    getPPVPurchaseOption: (userOperator) => {
        const configs = getConfiguration();
        userOperator = (userOperator || '').toLowerCase();
        let operatorConfig = configs?.operators;
        operatorConfig = Object.keys(operatorConfig || {}).reduce((acc, operator) => {
            acc[operator.toLowerCase()] = operatorConfig[operator];
            return acc;
        }, {});
        if (!userOperator || !operatorConfig) return PPV_PURCHASE_OPTIONS.NONE;
        const userOperatorConfig = operatorConfig[userOperator];
        if (!userOperatorConfig) return PPV_PURCHASE_OPTIONS.NONE;
        const purchaseOption = userOperatorConfig['ppv']?.defaultPurchaseOption?.toUpperCase();
        return userOperatorConfig['ppv'].enable ? PPV_PURCHASE_OPTIONS[purchaseOption] : PPV_PURCHASE_OPTIONS.NONE;
    },

    getTVODAlternativePaymentMethods: (userOperator) => {
        const configs = getConfiguration();
        userOperator = (userOperator || '').toLowerCase();
        let operatorConfig = configs?.operators;
        if (!userOperator || !operatorConfig) return [];
        operatorConfig = Object.keys(operatorConfig || {}).reduce((acc, operator) => {
            acc[operator.toLowerCase()] = operatorConfig[operator];
            return acc;
        }, {});
        const userOperatorConfig = operatorConfig[userOperator];
        if (!userOperatorConfig) return [];
        const allowedPurchaseOptions = userOperatorConfig['tvod']?.otherAllowedPurchaseOptions ?? [];
        const alternativePayments = allowedPurchaseOptions.map((option) => TVODPurchaseOption[option]);
        return userOperatorConfig['tvod'].enable ? alternativePayments : [];
    },

    getPPVAlternativePaymentMethods: (userOperator) => {
        const configs = getConfiguration();
        userOperator = (userOperator || '').toLowerCase();
        let operatorConfig = configs?.operators;
        if (!userOperator || !operatorConfig) return [];
        operatorConfig = Object.keys(operatorConfig || {}).reduce((acc, operator) => {
            acc[operator.toLowerCase()] = operatorConfig[operator];
            return acc;
        }, {});
        const userOperatorConfig = operatorConfig[userOperator];
        if (!userOperatorConfig) return [];
        const allowedPurchaseOptions = userOperatorConfig['ppv']?.otherAllowedPurchaseOptions ?? [];
        const alternativePayments = allowedPurchaseOptions.map((option) => PPV_PURCHASE_OPTIONS[option]);
        return userOperatorConfig['ppv'].enable ? alternativePayments : [];
    },
    checkTVODUserMsisdnValidity(prefixes) {
        const msisdn = this.getMSISDN();
        for (let prefix of prefixes) {
            // Check if the msisdn starts with the current prefix
            if (msisdn && msisdn.startsWith(prefix)) {
                return true; // Return true if any prefix matches
            }
        }
        return false;
    },
    getPreferredAudioLanguage: () => {
        const selectedProfile = h.getStore(STORE_NAME.SELECTED_PROFILE);
        const preferredAudioLanguage = selectedProfile?.defaultAudioLang ?? '';
        return preferredAudioLanguage;
    },
};

export default user;
